"use client";

import {
  createContext,
  useCallback,
  useState,
  useMemo,
  useContext,
} from "react";

const AccordionContext = createContext();

export function useAccordionContext() {
  return useContext(AccordionContext);
}

export default function AccordionContextProvider({
  children,
  defaultExpanded = "",
}) {
  const [activeItem, setActiveItem] = useState(defaultExpanded);

  const setToggle = useCallback(
    (value) => {
      setActiveItem(() => {
        if (activeItem !== value) return value;
        return "";
      });
    },
    [setActiveItem, activeItem],
  );

  const value = useMemo(
    () => ({
      setToggle,
      activeItem,
    }),
    [setToggle, activeItem],
  );

  return (
    <AccordionContext.Provider value={value}>
      {children}
    </AccordionContext.Provider>
  );
}
